<template>
  <v-app>
    <AppBar />
    <SideNavigation />
    <v-main style="position: relative" class="background_color overflow-y-auto">
      <v-container
        fluid
        class="pa-0"
        style="height: 100% !important; position: absolute"
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "@/components/BaseComponents/AppBar.vue";
import SideNavigation from "@/components/BaseComponents/SideNavigation.vue";

export default {
  name: "adminLayout",
  components: {
    AppBar,
    SideNavigation,
  },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    getUserProfile() {
      this.$api.profile
        .getUserProfile()
        .then((res) => {
          this.$permissions.setPermissions(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.getUserProfile();
  },
};
</script>
